import { Download, fileNameWithTime } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eReportNhapHocActionsObj } from "../../action-types/report/IReportNhapHocActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const reportNhapHocActions = {
  ...generateActions(eReportNhapHocActionsObj, "REPORT_NHAP_HOC"),
  ...generateActionForKey(
    eReportNhapHocActionsObj,
    "REPORT_NHAP_HOC",
    "EXPORT_EXCEL_BAO_CAO_SUCCESS",
    (data: any) => {
      // Không có dòng nào khớp bộ lọc -> dữ liệu rỗng; tải về sẽ ra file hỏng, mở lên Excel
      // báo "định dạng không hợp lệ". Báo rõ cho người dùng thay vì tải file lỗi.
      if (!data) {
        NotifyHelper.Error("Không có dữ liệu phù hợp với bộ lọc đang chọn.");
        return;
      }
      Download.Excel(data, `${fileNameWithTime("Báo cáo tổng hợp nhập học")}.xlsx`);
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eReportNhapHocActionsObj,
    "REPORT_NHAP_HOC",
    "EXPORT_EXCEL_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
};
